var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3222_103164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1686 13.3908C9.75128 13.8081 9.54262 14.0168 9.30419 14.0897C9.09464 14.1538 8.86983 14.1472 8.66435 14.0711C8.43056 13.9845 8.23438 13.764 7.84202 13.3232L4.9374 10.0595C4.66226 9.75033 4.68945 9.27676 4.99816 9.00112C5.30788 8.72459 5.78331 8.75222 6.05892 9.06277L9.02945 12.41L15.4395 5.99997C15.7322 5.70726 16.2067 5.70726 16.4995 5.99997C16.7922 6.29268 16.7922 6.76726 16.4995 7.05997L10.1686 13.3908Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3222_103164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxCheck);
export default __webpack_public_path__ + "static/media/icon_20px_check.9ea9a86725269f37a7f13ef4ea1727f6.svg";
export { ForwardRef as ReactComponent };